import { lazy, Suspense } from 'react';
import { cn } from '@/lib/cn';
import type { RichTextEditorProps } from './rich-text-editor';

// TipTap is heavy, so the editor loads on first use instead of in the main bundle.
const Editor = lazy(() => import('./rich-text-editor').then((m) => ({ default: m.RichTextEditor })));

/** WYSIWYG editor (TipTap). Output is HTML; the API sanitizes it before storing. */
export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense
      fallback={
        <div
          aria-busy="true"
          className={cn('rounded-md border border-border-strong bg-surface shadow-card', props.className)}
          style={{ minHeight: (props.minHeight ?? 160) + 37 }}
        />
      }
    >
      <Editor {...props} />
    </Suspense>
  );
}

/** Renders HTML that the API has already sanitized (documents, ticket messages). */
export const RichTextView = ({ html, className }: { html: string | null | undefined; className?: string }) =>
  html ? <div className={cn('prose-flow text-sm', className)} dangerouslySetInnerHTML={{ __html: html }} /> : <p className="text-sm text-subtle">Nothing written yet.</p>;
